module.exports = __webpack_public_path__ + "static/media/circle.1c7f9b5c.svg";